export const baseURL = 'https://www.servicefun.cn'
// export const baseURL = 'http://192.168.0.79:8080'
// export const baseURL = 'http://localhost:8181'

// export const baseURL = 'http://192.168.1.62:8080'
// export const baseURL = 'http://3qt5472829.picp.vip'
// export const baseURL = 'http://47.109.139.183:8080'
// export const baseURL = 'http://test-servicefun.serviceli.cn/'
// export const baseURL = ''
// export const baseURL = 'http://192.168.0.177:8848'
export const IPURL = 'http://http://47.104.23.195'



// WEBPACK FOOTER //
// ./src/config.js